export class StringUtils {
	public static isNotBlank(str: string) {
		return str && str.trim() !== '';
	}

	public static isBlank(str: string) {
		return !str || str.trim() === '';
	}

	public static escapeHtml(text: string) {
		return text.escapeHtml();
	}

	/**
	 * Add padding to the beginning of the input string to fill it out to a certain length.
	 *
	 * @param {string} str The input string
	 * @param {number} length The minimum length of the output string.
	 * @param {string} paddingCharacter A string of length one (a character) with which to pad the input string.
	 * @returns {string} The padded string.
	 */
	public static padStart(
		str: string,
		length: number,
		paddingCharacter: string,
	) {
		const s = str || '';
		return StringUtils.makePad(s, length, paddingCharacter) + s;
	}

	/**
	 * Add padding to the end of the input string to fill it out to a certain length.
	 *
	 * @param {string} str The input string
	 * @param {number} length The minimum length of the output string.
	 * @param {string} paddingCharacter A string of length one (a character) with which to pad the input string.
	 * @returns {string} The padded string.
	 */
	public static padEnd(
		str: string,
		length: number,
		paddingCharacter: string,
	) {
		const s = str || '';
		return s + StringUtils.makePad(s, length, paddingCharacter);
	}

	/**
	 * Find the occurances of a target string.
	 * @param str string to search against
	 * @param search string tosearch
	 * @returns empty if no matching. indexes of occurance of the search string
	 */
	public static indexesOf(str: string, search: string): number[] {
		const result = [];
		const step = search.length;
		for (let i = 0; i <= str.length - step; i++) {
			if (str.substring(i, i + step) === search) {
				result.push(i);
			}
		}
		return result;
	}

	/**
	 * Capitalize the provided string
	 * @param str string to capitalize
	 * @returns capitalized string (client -> Client)
	 */
	public static capitalize(str: string): string {
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	}

	/**
	 * Create padding for the input string such that the padding concatenated with the input string is at least a
	 * certain length.
	 *
	 * @param {string} str The input string. This must not be null or undefined.
	 * @param {number} length The minimum length for the concatenation of the input string and the output padding.
	 * @param {string} paddingCharacter A string of length one (a character) with which to pad the input string.
	 * @returns {string} The padding string.
	 */
	private static makePad(
		str: string,
		length: number,
		paddingCharacter: string,
	) {
		if (!paddingCharacter || paddingCharacter.length !== 1) {
			throw new Error('The requested padding is not a character');
		}
		const padLength = (length ? length : 0) - str.length;
		return paddingCharacter.repeat(padLength > 0 ? padLength : 0);
	}
}
